<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/prestador">Prestador</router-link>
            > {{ datoPrestador.razonSocial }}
          </div>
        </div>
        <div class="col-1">
          <span
            class="material-symbols-outlined"
            style="font-size: 32px; color: blue; cursor: pointer"
            @click="showModalHelp = true"
          >
            help
          </span>
        </div>
      </div>
    </div>
    <hr />
    <!-- Modal -->
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <form>
          <div class="modal-body">
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="razonSocial" class="form-label"
                    >RazonSocial</label
                  >
                </div>
                <div class="col-10">
                  <input
                    class="form-control"
                    id="razonSocial"
                    name="razonSocial"
                    v-model="datoPrestador.razonSocial"
                    style="text-transform: uppercase"
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombreComercial" class="form-label"
                    >Nombre Comercial</label
                  >
                </div>
                <div class="col-10">
                  <input
                    class="form-control"
                    id="nombreComercial"
                    name="nombreComercial"
                    v-model="datoPrestador.nombreComercial"
                    style="text-transform: uppercase"
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="ruc" class="form-label">Ruc</label>
                </div>
                <div class="col-4">
                  <input
                    type="text"
                    class="form-control"
                    id="ruc"
                    name="ruc"
                    v-model="datoPrestador.ruc"
                    style="text-transform: uppercase"
                    required
                  />
                </div>
                <div class="col-2">
                  <label for="idPrestador" class="form-label"
                    >Id. Prestador</label
                  >
                </div>
                <div class="col-4">
                  <input
                    type="text"
                    class="form-control"
                    id="idPrestador"
                    name="idPrestador"
                    v-model="datoPrestador.idPrestador"
                    disabled
                  />
                </div>
              </div>
            </div>

			
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label"
                    >Fecha de registro</label
                  >
                </div>
                <div class="col-4">
                  <input
                    type="text"
                    class="form-control"
                    id="fechaReg"
                    name="fechaReg"
                    v-model="datoPrestador.fechaReg"
                    disabled
                  />
                </div>
                <div class="col-2">
                  <label for="fechaAct" class="form-label">Fecha de actualización</label>
                </div>
                <div class="col-4">
                  <input
                    type="text"
                    class="form-control"
                    id="fechaAct"
                    name="fechaAct"
                    v-model="datoPrestador.fechaAct"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="modal-footer">
          <div class="me-auto">
          </div>
          <button
            type="submit"
            class="btn btn-light"
            @click.prevent="guardarPrestador"
            title="Guardar"
          >
            <i
              class="material-icons"
              style="font-size: 32px; color: blue; cursor: pointer"
              >save</i
            >Actualizar
          </button>
        </div>
      </div>
    </div>
	
<!-- Estructura de Tabs -->
<div class="tab-bar">
  <button
    class="tablink"
    @click="showTable = 'equivalencia'"
    :class="{ 'active-tab': showTable === 'equivalencia' }"
  >
    <span class="material-symbols-outlined">table_chart</span>
    Tabla de equivalencia
  </button>
  <button
    class="tablink"
    @click="showTable = 'tarifario'"
    :class="{ 'active-tab': showTable === 'tarifario' }"
  >
    <span class="material-symbols-outlined">payments</span>
    Tarifario
  </button>

  <!-- Dropdown: Registro tarifario -->
  <div class="tab-dropdown" ref="dropTarifa">
    <button
      class="tablink tab-dropdown-btn"
      :class="{ 'active-tab': ['tarifarioReg', 'tarifarioRegCSV'].includes(showTable) }"
      @click="toggleDropdown('tarifa')"
    >
      <span class="material-symbols-outlined">add_circle</span>
      Registrar tarifario
      <span class="material-symbols-outlined" style="font-size:16px">expand_more</span>
    </button>
    <div class="tab-dropdown-menu" v-show="dropdownAbierto === 'tarifa'">
      <button
        class="tab-dropdown-item"
        :class="{ 'active-item': showTable === 'tarifarioReg' }"
        @click="setTab('tarifarioReg')"
      >
        <span class="material-symbols-outlined">edit_note</span> Insertar registro
      </button>
      <button
        class="tab-dropdown-item"
        :class="{ 'active-item': showTable === 'tarifarioRegCSV' }"
        @click="setTab('tarifarioRegCSV')"
      >
        <span class="material-symbols-outlined">upload_file</span> Carga desde CSV
      </button>
    </div>
  </div>
</div>

<!-- Contenido dinámico -->
<div v-if="showTable === 'equivalencia'">
  <ElemPres
    :p_idEmpresa="Number(datoPrestador.idEmpresa)"
    :p_idPrestador="Number(datoPrestador.idPrestador)"
  />
</div>
<div v-if="showTable === 'tarifario'">
  <TarifaPres
    :p_idEmpresa="Number(datoPrestador.idEmpresa)"
    :p_idPrestador="Number(datoPrestador.idPrestador)"
  />
</div>
<div v-if="showTable === 'tarifarioReg'">
  <TarifaPresRegistro :p_idPrestador="p_idPrestador" />
</div>
<div v-if="showTable === 'tarifarioRegCSV'">
  <TarifaPresRegistroCSV :p_idPrestador="p_idPrestador" />
</div>
    <Footer />
  </div>
</template>
<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import { validarForm } from "../../modules/validacionesForms.js";
import ElemPres from "@/views/forms/ElemPres.vue";
import TarifaPres from "@/views/forms/TarifaPres.vue";
import TarifaPresRegistro from "@/components/TarifaPresRegistro.vue";
import TarifaPresRegistroCSV from "@/components/TarifaPresRegistroCSV.vue";

import api from "@/services/api";
import dateFormat from "@/modules/dateFormat.js";
//import { format } from "date-fns";

import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";
export default {
  components: {
    Layout,
    Footer,
    ElemPres,
    TarifaPres,
    TarifaPresRegistro,
    TarifaPresRegistroCSV
  },
  data() {
    return {
      prestadors: [],
      datoPrestador: {},
      nombreBusqueda: "",
      titulo: "",
      btnEditar: false,
      modalWindow: true,
      p_idPrestador: 0,
      showTable: '',
      dropdownAbierto: null,
    };
  },
  /*
  computed: {
    formattedFechaReg() {
      const originalDate = new Date(this.datoAuto.fechaReg);
      return format(originalDate, 'dd/MM/yyyy');
    },
  },
*/

  mounted() {
    this.p_idPrestador = this.$route.params.p_idprestador;
	
    this.getData();
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    document.addEventListener('click', this.cerrarDropdowns);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.cerrarDropdowns);
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    getData() {
      api.get("/vwprestadors/" + this.p_idPrestador)
        .then((response) => {
          this.datoPrestador = response.data;
        })
        .catch((error) => {
          console.error("Error al obtener datos de la persona:", error);
        });
    },
    validarForm() {
      const requiredFields = ["razonSocial", "nombreComercial", "ruc"];
      const requiredFieldsText = ["razonSocial", "nombreComercial", "ruc"];
      return validarForm(
        this.datoPrestador,
        requiredFields,
        requiredFieldsText
      );
    },
    async guardarPrestador() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/prestadors",
            this.datoPrestador
          );
          swal("Correcto!", "Prestador creada exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
toggleDropdown(nombre) {
  this.dropdownAbierto = this.dropdownAbierto === nombre ? null : nombre;
},
setTab(nombre) {
  this.showTable = nombre;
  this.dropdownAbierto = null;
},
cerrarDropdowns(event) {
  const tarifaRef = this.$refs.dropTarifa;
  if (!tarifaRef || !tarifaRef.contains(event.target)) {
    this.dropdownAbierto = null;
  }
},
  },
};
</script>
<style scoped>
.tab-bar {
  display: flex;
  align-items: stretch;
  gap: 4px;
  border-bottom: 2px solid #dee2e6;
  background: #f8f9fa;
  border-radius: 8px 8px 0 0;
  padding: 6px 8px 0;
  flex-wrap: wrap;
}
.tablink {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 12px 8px;
  border: 1px solid transparent;
  border-bottom: none;
  background: none;
  cursor: pointer;
  font-size: 15px;
  color: #6c757d;
  border-radius: 6px 6px 0 0;
  white-space: nowrap;
  transition: background .15s, color .15s;
}
.tablink:hover { background: #e9ecef; color: #343a40; }
.active-tab {
  background: #fff;
  color: #0d6efd;
  border-color: #dee2e6;
  font-weight: 500;
  margin-bottom: -2px;
  border-bottom: 2px solid #fff;
}
.tab-dropdown { position: relative; }
.tab-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  min-width: 210px;
  z-index: 200;
  margin-top: 4px;
  box-shadow: 0 4px 12px rgba(0,0,0,.1);
}
.tab-dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  font-size: 15px;
  color: #343a40;
  cursor: pointer;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
}
.tab-dropdown-item:hover { background: #f0f4ff; color: #0d6efd; }
.tab-dropdown-item.active-item { color: #0d6efd; font-weight: 500; }
</style>
